<section class="workspace-page workspace-page--full">
  <app-selection-summary *ngIf="selections.length" [selections]="selections"
                         [activeFeatureKey]="active?.feature?.key ?? null"
                         (featureSelected)="openFeature($event)"
                         (clearAll)="selectionContext.clearAll()"></app-selection-summary>
  <ng-container *ngIf="detail$ | async as detail; else selectedRecords">
      <label *ngIf="selectionBinding && active?.objectIds?.length === 1" class="br-flex br-items-center br-gap-2">
        <input type="checkbox" aria-label="Select object"
               [checked]="selectionBinding.has(active!.objectIds[0])"
               (change)="selectionBinding.setSelected([active!.objectIds[0]], $any($event.target).checked)" />
        Selected
      </label>
      <div class="br-text-muted">{{ detail.type }}</div>
      <h1 class="workspace-title">{{ detail.title }}</h1>
      <p *ngIf="detail.subtitle">{{ detail.subtitle }}</p>
      <dl class="selection-facts">
        <ng-container *ngFor="let fact of detail.values">
          <ng-container *ngIf="fact.value !== null && fact.value !== undefined && fact.value !== ''">
            <dt>{{ fact.label }}</dt><dd>{{ format(fact.value) }}</dd>
          </ng-container>
        </ng-container>
      </dl>
      <section *ngFor="let related of detail.sections" class="br-card br-mt-3">
        <div class="br-card-body">
          <div class="br-text-muted">{{ related.type }}</div>
          <h2>{{ related.title }}</h2>
          <dl class="selection-facts">
            <ng-container *ngFor="let fact of related.values">
              <ng-container *ngIf="fact.value !== null && fact.value !== undefined && fact.value !== ''">
                <dt>{{ fact.label }}</dt><dd>{{ format(fact.value) }}</dd>
              </ng-container>
            </ng-container>
          </dl>
        </div>
      </section>
  </ng-container>
  <ng-template #selectedRecords>
  <p *ngIf="!active" class="br-text-muted" role="status">Select objects on the map to view them here.</p>
  <p *ngIf="loading" role="status">Loading selection…</p>
  <div *ngIf="error" role="alert">
    {{ error }} <button type="button" class="br-btn br-btn--secondary br-btn--sm" (click)="load()">Retry</button>
  </div>
  <app-customers class="selection-business" *ngIf="active?.feature?.key === 'customers'"
                 [selectedIds]="selectedRecordIds" [selectionBinding]="selectionBinding"></app-customers>
  <app-leads-board class="selection-business" *ngIf="active?.feature?.key === 'leads'"
                   [selectedIds]="selectedRecordIds" [selectionBinding]="selectionBinding"></app-leads-board>
  <div class="selection-table" *ngIf="fetch">
    <app-data-table [columns]="columns" [fetch]="fetch" [filters]="filters"
                    [selectable]="selectionBinding !== null" [selectionBinding]="selectionBinding"
                    searchPlaceholder="Find selected ID…">
      <ng-template dtCell="id" let-row>{{ row.id }}</ng-template>
      <ng-template dtCell="name" let-row>
        <a *ngIf="row.path; else plainName" [routerLink]="row.path">{{ row.name }}</a>
        <ng-template #plainName>{{ row.name }}</ng-template>
      </ng-template>
      <ng-template dtCell="description" let-row>{{ row.description }}</ng-template>
    </app-data-table>
  </div>
  </ng-template>
</section>
